import React from 'react'
import as6 from '../images/as6.jpeg'

const Contact = () => {
  return (
    <main className='as'>
      <header>
        <img src={as6} alt="" height='600px' />
      </header>
      
       <section className='contact-parent'>
        <div className="map">
             <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d290138.49342137855!2d36.1812292039175!3d55.38056973033748!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46cab9136d437f7d%3A0xbbe942e074a4ec9f!2z0J3QsNGA0L4t0KTQvtC80LjQvdGB0LrQuNC5INCz0L7RgNC-0LTRgdC60L7QuSDQvtC60YDRg9CzLCDQnNC-0YHQutC-0LLRgdC60LDRjyDQvtCx0LsuLCDQoNC-0YHRgdC40Y8!5e0!3m2!1sru!2sam!4v1780571735583!5m2!1sru!2sam" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <div className="contact">
             <h2>Контакты</h2>
             <ul>
            <i className="bi bi-geo-alt"></i>  <li> Наро-Фоминск,Селятино</li>
              <i className="bi bi-telephone"></i> <li className='x'><a href="tel:+7-964-514-46-40 ">+7-964-514-46-40 </a></li>
            <i className="bi bi-globe2"></i>  <li>МАК-СТРОЙ</li>
            <i className='bi bi-envelope'></i> <li>makich.avetisyan88@mail.ru</li>
             </ul>
        </div>
       </section>
   </main>
  )
}

export default Contact
